import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { Factor } from "../../models/matriz/Factor";
import { useForm } from "react-hook-form";
import { FactorService } from "../../service/matriz/FactorService";
import { InputComponent } from "../../components/InputComponent";
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { ItemFactor } from "./ItemFactor";
import { Generico } from "../../components/Generico";
import { AreaFactor } from "./AreaFactor";
import { Button } from "primereact/button";
import { Catalogo } from "../../components/Catalogo";
import { ParametroMatriz } from "./ParametroMatriz";
import { EmpresaLista } from "../administracion/EmpresaLista";

export const Factores = () => {

    const omodel = new Factor();
    const generic = new GenericComponent();
    const [permss, setPermss] = useState(null);
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues, shouldTrim: true });
    const [registers, setRegisters] = useState(null);
    const factorSrv = new FactorService();
    const toast = useRef(null);
    const [dialogFactor, setDialogFactor] = useState(false);
    const [dialogCatalogo, setDialogCatalogo] = useState(false);
    const [factor, setFactor] = useState(null);
    const [dialogArea, setDialogArea] = useState(false);
    const [dialogNegocio, setDialogNegocio] = useState(false);
    const [dialogConfigurar, setDialogConfigurar] = useState(false);
    const [dialogEmpresa, setDialogEmpresa] = useState(false);
    const urlCatalogo = {
        listar: 'catalogo/area-matriz/lista',
        consultar: 'catalogo/area-matriz/consulta',
        editar: 'catalogo/area-matriz/editar',
        eliminar: 'catalogo/area-matriz/eliminar',
        nuevo: 'catalogo/area-matriz/nuevo'
    };
    const [catalogo, setCatalogo] = useState(null);
    const { table, setLoading, setTotalRecords, lazyParams, inDrop, inText, inNumber } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        factorSrv.lista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogo(res.data.catalogos);
            }
        });
    }

    const openNew = () => {
        setFactor(null);
        reset(defaultValues);
        setDialogFactor(true);
    }

    const edit = () => {
        factorSrv.consultar(factor?.id).then(res => {
            const lista = { estado: generic.estados };
            let _factor = res.data;

            Object.keys(lista).forEach(function (key) {
                if (_factor[key] != null) {
                    lista[key].forEach(element => {
                        if (element.cat_id === _factor[key]) {
                            _factor[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_factor, omodel.model));
            setDialogFactor(true);
        });
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el factor?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                factorSrv.eliminar(factor?.id).then(res => {
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Factor eliminado', life: 3000 });
                    loadLazyData();
                });
            }
        });
    }

    const onSubmit = (data) => {
        if (data.id == null) {
            factorSrv.nuevo(data).then(res => {
                generic.funcSuccess(res, toast);
                loadLazyData();
                setDialogFactor(false);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            factorSrv.editar(data).then(res => {
                generic.funcSuccess(res, toast);
                loadLazyData();
                setDialogFactor(false);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar factor', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.actualizar)
            items.push({ label: 'Lista de ítems', icon: 'pi pi-qrcode', command: () => { setDialogCatalogo(true) } });
        if (permss?.actualizar)
            items.push({ label: 'Area Negocio - plantilla', icon: 'pi pi-directions-alt', command: () => { setDialogArea(true) } });
        if (permss?.actualizar)
            items.push({ label: 'Area Negocio - empresa - plantilla', icon: 'pi pi-building-columns', command: () => { setDialogEmpresa(true) } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const startContent = (
        <>
            {permss?.crear && <Button icon="pi pi-plus" className="mr-2" tooltip="Nuevo factor" onClick={openNew} />}
            {permss?.crear && <Button icon="pi pi-th-large" className="mr-2" tooltip="Configurar áreas de negocio" onClick={() => setDialogNegocio(true)} />}
            {permss?.crear && <Button icon="pi pi-calculator" className="mr-2" tooltip="Parámetros" onClick={() => setDialogConfigurar(true)} />}
        </>
    );

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />

            {!dialogCatalogo && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={startContent}></Toolbar>
                {table({ action01: accionesTbl, reg: setFactor, items: itemsMenu() })}
            </Card>}

            <Dialog visible={dialogFactor} header={getValues('id') == null ? "Nuevo factor" : "Editar factor"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogFactor(false)} style={{ maxWidth: '400px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 12)}
                        {inText('nemonico', {}, 12)}
                        {inNumber('ponderacion', 0, false, {}, 6)}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 6)}
                    </div>

                    {generic.buttonsForms(setDialogFactor)}
                </form>
            </Dialog>

            <Dialog visible={dialogArea} header={"Area negocio por plantilla, factor :" + factor?.nombre} modal className="p-fluid modal-ssize"
                onHide={e => setDialogArea(false)} style={{ maxWidth: '800px' }}>
                <AreaFactor permss={permss} generic={generic} toast={toast} factor={factor} catalogo={catalogo} />
            </Dialog>

            <Dialog visible={dialogNegocio} header="Configurar área de negocio" modal className="p-fluid modal-ssize"
                onHide={e => setDialogNegocio(false)} style={{ maxWidth: '800px' }}>
                <Catalogo permss={permss} toast={toast} urls={urlCatalogo} opcion={null} />
            </Dialog>

            <Dialog visible={dialogConfigurar} header="Crear parámetros iniciales por empresa" modal className="p-fluid modal-ssize"
                onHide={e => setDialogConfigurar(false)} style={{ maxWidth: '800px' }} >
                <ParametroMatriz generic={generic} permss={permss} toast={toast} catalogo={catalogo} />
            </Dialog>

            <Dialog visible={dialogEmpresa} header={"Asignar áreas a empresa: " + factor?.nombre} modal className="p-fluid modal-ssize" onHide={e => setDialogEmpresa(false)}
                style={{ maxWidth: '900px' }}>
                <EmpresaLista valor={factor} toast={toast} generic={generic} permss={permss} opcion='area' catalogo={catalogo} />
            </Dialog>

            {dialogCatalogo && <ItemFactor generic={generic} fact={factor} toast={toast} permss={permss} setRegresar={setDialogCatalogo} />}
        </>
    )
}
